import { useState } from "react";
import { Calendar } from "lucide-react";

const PRESETS = [
  { key: "all", label: "All time" },
  { key: "today", label: "Today" },
  { key: "week", label: "This week" },
  { key: "month", label: "This month" },
  { key: "quarter", label: "This quarter" },
  { key: "year", label: "This year" },
];

function isoStart(d) { d.setHours(0, 0, 0, 0); return d.toISOString(); }
function isoEnd(d) { d.setHours(23, 59, 59, 999); return d.toISOString(); }

function presetRange(key) {
  const now = new Date();
  if (key === "all") return { from: "", to: "" };
  if (key === "today") return { from: isoStart(new Date(now)), to: isoEnd(new Date(now)) };
  if (key === "week") {
    const d = new Date(now); const day = d.getDay() || 7; d.setDate(d.getDate() - day + 1);
    return { from: isoStart(d), to: isoEnd(new Date(now)) };
  }
  if (key === "month") {
    const d = new Date(now.getFullYear(), now.getMonth(), 1);
    return { from: isoStart(d), to: isoEnd(new Date(now)) };
  }
  if (key === "quarter") {
    const q = Math.floor(now.getMonth() / 3);
    const d = new Date(now.getFullYear(), q * 3, 1);
    return { from: isoStart(d), to: isoEnd(new Date(now)) };
  }
  if (key === "year") {
    const d = new Date(now.getFullYear(), 0, 1);
    return { from: isoStart(d), to: isoEnd(new Date(now)) };
  }
  return { from: "", to: "" };
}

export default function DateRange({ value, onChange, showAsOf = false, testId = "date-range" }) {
  const [preset, setPreset] = useState("all");
  const inputCls = "bg-white border border-border rounded-md px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary text-sm";

  const applyPreset = (k) => {
    setPreset(k);
    const { from, to } = presetRange(k);
    onChange({ from, to });
  };

  const setFrom = (v) => onChange({ ...value, from: v ? new Date(v).toISOString() : "" });
  const setTo = (v) => onChange({ ...value, to: v ? isoEnd(new Date(v)) : "" });

  const fromDate = value.from ? value.from.slice(0, 10) : "";
  const toDate = value.to ? value.to.slice(0, 10) : "";

  return (
    <div className="flex flex-wrap items-end gap-3" data-testid={testId}>
      <div className="flex flex-wrap items-center gap-1">
        <Calendar className="w-3.5 h-3.5 text-muted-foreground mr-1" />
        {PRESETS.map((p) => (
          <button key={p.key} onClick={() => applyPreset(p.key)} type="button"
            className={`px-2.5 py-1 rounded-md text-xs transition-colors ${preset === p.key ? "bg-forest text-white" : "border border-border hover:bg-muted"}`}
            data-testid={`${testId}-preset-${p.key}`}>{p.label}</button>
        ))}
      </div>
      <div className="flex items-end gap-2">
        <div>
          <div className="label mb-1">{showAsOf ? "As of" : "From"}</div>
          {!showAsOf && <input type="date" className={inputCls} value={fromDate} onChange={(e) => setFrom(e.target.value)} data-testid={`${testId}-from`} />}
          {showAsOf && <input type="date" className={inputCls} value={toDate} onChange={(e) => setTo(e.target.value)} data-testid={`${testId}-asof`} />}
        </div>
        {!showAsOf && (
          <div>
            <div className="label mb-1">To</div>
            <input type="date" className={inputCls} value={toDate} onChange={(e) => setTo(e.target.value)} data-testid={`${testId}-to`} />
          </div>
        )}
      </div>
    </div>
  );
}
